import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/error-page',
        name: 'Error Page',
        component: () => import('@/components/routes/ErrorRoute'),
        meta: {
            name: 'Error Page'
        }
    },
    {
        path: '/:urlCode/coupons/:couponId',
        name: 'Coupon View',
        component: () => import('@/components/routes/CouponViewRoute'),
        meta: {
            routeTitle: 'Coupon View'
        },
        props: true
    },
    {
        path: '/:urlCode',
        name: 'Coupons List',
        component: () => import('@/components/routes/CouponsListRoute'),
        meta: {
            name: 'Coupons List'
        },
        props: true
    },
    {
        path: '/uni-student/:urlCode',
        name: 'Uni Student Coupons List',
        component: () => import('@/components/routes/StudentCouponsListRoute'),
        meta: {
            name: 'Uni Student Coupons List'
        },
        props: true
    },
    {
        path: '/uni-student/:urlCode/coupons/:couponId',
        name: 'Uni Student Coupon View',
        component: () => import('@/components/routes/CouponViewRoute'),
        meta: {
            name: 'Uni Student Coupon View'
        },
        props: true
    }
]

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_PUBLIC_PATH),
    routes
})
router.beforeEach((to, from, next) => {
    next()
})

export default router
